import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ValidatorType } from 'src/app/utility/enum/global-enum';
import { FileHandlerService, IFileOptions } from 'src/app/utility/services/file-handler/file-handler.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { IFileExtend } from '../../model/IFileExtend';
import { IndClaimSubmission } from '../../model/ind-claim-submission';
import { FileValidatorService } from '../../service/file-validator/file-validator.service';
import { IndividualClaimSubmissionService } from '../../service/individual-claim-submission/individual-claim-submission.service';
import { OtpService } from '../../service/otp/otp.service';
import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
  selector: 'app-online-additional-document-upload-ind',
  templateUrl: './online-additional-document-upload-ind.component.html',
  styleUrls: ['./online-additional-document-upload-ind.component.scss']
})
export class OnlineAdditionalDocumentUploadIndComponent implements OnInit {

  @Output() onDocumentUploadDone: EventEmitter<any> = new EventEmitter();

  allRequiredDocs: IFileExtend[] = [];
  fileExtends: IFileExtend[] = [];
  fileOption: IFileOptions = { acctptedTypes: "" };
  isDocSubmission: boolean;
  claimEntryId: number;
  patientName: string;
  browserId: string;
  securityToken: string;
  //fileExtend: IFileExtend;
  inputForm = this.fb.group({
  });


  constructor(
    private fb: FormBuilder,
    private individualClaimSubmissionService: IndividualClaimSubmissionService,
    private messageService: MessageService,
    private fileHandlerService: FileHandlerService,
    private fileValidatorService: FileValidatorService,
    private otpService: OtpService
  ) { }

  ngOnInit() {
  }

  initialize(claimEntryId: number, browserId: string, securityToken: string) {
    this.claimEntryId = claimEntryId;
    this.browserId = browserId;
    this.securityToken = securityToken;
    this.getFileExtension();
    this.resetFiles();
    this.getDocs();
  }

  private getDocs() {
    this.individualClaimSubmissionService.getDocumentsAndPatientName(this.claimEntryId)
      .subscribe((res: any) => {
        this.patientName = res.patientName;
        this.fileExtends = res.requiredDocuments;
        this.allRequiredDocs = res.requiredDocuments;
        this.allRequiredDocs.forEach(obj => {
          obj.index = 1;
        });
      });
  }

  onFileChange(event, item: any) {
    if (
      event &&
      this.fileHandlerService.validator(event.target.files[0], this.fileOption)
    ) {
      item.file = event.target.files[0];
      this.documentRequiredValidation();
    }
  }

  documentRequiredValidation() {
    //As All documents are mandatory. So check the number of required document and number of uploaded documents
    let rerquiredfile = 0;
    this.fileExtends.forEach(ele => {
      if (!ele.isOptional) {
        rerquiredfile++;
      }
    });
    let uploadedFile = 0;
    this.fileExtends.forEach(x => {
      if (x.file != null && !x.isOptional) {
        uploadedFile++;
      }
    });

    if (rerquiredfile === uploadedFile) {
      this.isDocSubmission = false;
    } else {
      this.isDocSubmission = true;
    }
  }

  getFileExtension() {
    this.fileValidatorService
      .getByValidatorType(ValidatorType.GroupClaimSubmission)
      .subscribe(
        res => {
          this.fileOption.validators = res;
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  addDocument(item: IFileExtend) {
    let index = 0;
    const obj = this.fileExtends.filter(x => x.documentId === item.documentId);
    obj.forEach(element => {
      if (element.index > index) {
        index = element.index;
      }
    });

    this.fileExtends.push({
      documentId: item.documentId,
      docName: item.docName,
      file: null,
      acctptedTypes: "",
      index: index + 1,
      isOptional: item.isOptional
    });

    this.fileExtends = this.fileExtends.sort((t1, t2) => {
      if (t1.documentId > t2.documentId) {
        return 1;
      }
      if (t1.documentId < t2.documentId) {
        return -1;
      }
      return 0;
    });
    this.documentRequiredValidation();
  }

  removeDocument(item: IFileExtend) {
    this.fileExtends = this.fileExtends.filter(x => x !== item);
    this.documentRequiredValidation();
  }

  viewDocument(file) {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }

  clearUpload(item) {
    item.file = null;
    this.documentRequiredValidation();
  }

  submit() {
    const data = this.getClaimSubmissionDocumentData();
    this.individualClaimSubmissionService.additionalDocumentSubmitInd(data).subscribe(
      res => {
        this.resetFiles();
        // ** Notify Parent
        this.notifyParentComponent(1);
        this.messageService.show("Document submitted successfully.", "success");
        this.individualClaimSubmissionService.clearRequestToken();
      },
      err => {
        this.messageService.show(err.error.message, "error");
      }
    );
  }

  getAdditionalDocumentData() {
    let entity = {
      componentValidatorId: ValidatorType.GroupClaimSubmission,
      claimEntryId: this.claimEntryId
    }
    const formData = this.getFormData(entity);
    return formData;
  }
  getClaimSubmissionDocumentData() {
    let entity = {
      componentValidatorId: ValidatorType.GroupClaimSubmission,
      claimEntryId: this.claimEntryId,
      //securityToken: this.securityToken,
    }
    const formData = this.getFormData(entity);
    return formData;
  }

  getFormData(data: any): FormData {
    let tempFileExtends = [...this.fileExtends];
    let formData = new FormData();
    formData.append("model", JSON.stringify(data));
    let additionalId: number = 0;
    tempFileExtends.forEach(x => {
      if (x.index != 0) {
        if (tempFileExtends.filter(f => f.documentId === x.documentId).length > 1)
          additionalId++;
      }
      formData.append(
        x.documentId.toString() + "-" + additionalId.toString(),
        x.file
      )
    });
    return formData;
  }

  resetFiles() {
    this.fileExtends = [];
    this.isDocSubmission = true;
  }

  notifyParentComponent(type: number) {
    const data = {
      isDocumentUploaded: (type == 1)? true: false,
      isResettable: (type == 2)? true: false
    }
    this.onDocumentUploadDone.emit(data);
  }

  cancel() {
    this.otpService.otpSessionCancel(this.browserId).subscribe(res => {
      this.notifyParentComponent(2);
    },
    err => {
      this.messageService.show(err.error.message, "error");
    });

  }

}
